import { TaskPositionDetailsComponent } from './component/task-position-details/task-position-details.component';
import { CommonUIModule,  ServiceResponseModule } from '@sdbn/common';
import { TaskAssignmentDialogComponent } from './component/task-assignment-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { TaskProcessingHintDialogComponent } from './component/task-position-details/task-processing-hint.dialog.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TaskListEntryComponent } from './component/task-list-entry/task-list-entry.component';
import { CommonTranslationModule } from '@sdbn/common';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    CommonUIModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  declarations: [
    TaskAssignmentDialogComponent,
    TaskPositionDetailsComponent,
    TaskProcessingHintDialogComponent,
    TaskListEntryComponent
  ],
  exports: [
    TaskPositionDetailsComponent
  ]
})
export class TaskAssignmentModule { }
